import React from 'react';
//images

const Header = () => {
  return <header className='py-8'>
    <div className='container mx-auto'>
      <div className='flex justify-between items-center'>
      </div>
    </div>
  </header>;
};

export default Header;
